import React from 'react';
import { FieldLocationAutocompleteInput } from '../../../components';
import {
  autocompleteSearchRequired,
  autocompletePlaceSelected,
  composeValidators,
} from '../../../util/validators';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './JobLocation.module.css';

const identity = v => v;

const JobLocation = ({ values, intl }) => {

  const addressRequiredMessage = intl.formatMessage({
    id: 'EditListingLocationForm.addressRequired',
  });
  const addressNotRecognizedMessage = intl.formatMessage({
    id: 'EditListingLocationForm.addressNotRecognized',
  });

  const showLocation =
    (values.transportation && values.transportation !== "selfArranged") ||
    (values.collectionOrShipping && values.collectionOrShipping === "shipping");

  return showLocation ? (
    <div className={css.root}>
      <h2 className={css.title}>
        <FormattedMessage id="BookingDatesForm.jobLocationTitle" />
      </h2>
      <p className={css.description}>
        <FormattedMessage id="BookingDatesForm.jobLocationDescription" />
      </p>

      <FieldLocationAutocompleteInput
        rootClassName={css.locationAddress}
        inputClassName={css.locationAutocompleteInput}
        iconClassName={css.locationAutocompleteInputIcon}
        predictionsClassName={css.predictionsRoot}
        validClassName={css.validLocation}
        name="jobLocation"
        placeholder={intl.formatMessage({
          id: 'BookingDatesForm.addressPlaceholder',
        })}
        useDefaultPredictions={false}
        format={identity}
        valueFromForm={values.jobLocation}
        validate={composeValidators(
          autocompleteSearchRequired(addressRequiredMessage),
          autocompletePlaceSelected(addressNotRecognizedMessage)
        )}
      />
    </div>
  ) : null;
}

export default JobLocation;
